import { PUNCTUATION } from '../../utils/constants/notation';
import { formatNumber } from '../../utils/utils';

/**
 * ValueWithYear - Displays a numeric value with a year superscript
 *
 * Used for financial data (Sales, Employees, Share %) where the data year
 * should be shown as a superscript next to the value.
 *
 * @param {string|number} value - The numeric value to display
 * @param {number|string} year - The year (will show last 2 digits as superscript)
 * @param {boolean} formatValue - Whether to apply formatNumber to the value (default: true)
 * @param {string} className - Additional CSS class for the container
 */
const ValueWithYear = ({ value, year, formatValue = true, className = '' }) => {
  // Handle empty/null values
  if (value === null || value === undefined || value === '') {
    return <span className={`value-with-year ${className}`.trim()}>{PUNCTUATION.EMPTY_VALUE}</span>;
  }

  // Format the display value
  const displayValue = formatValue && typeof value === 'number' ? formatNumber(value) : value;

  // Extract last 2 digits of year
  const yearSuffix = year?.toString?.()?.slice?.(-2);

  return (
    <span className={`value-with-year ${className}`.trim()}>
      <span className="value">{displayValue}</span>
      {yearSuffix && <sup className="year-sup">&lsquo;{yearSuffix}</sup>}
    </span>
  );
};

export default ValueWithYear;
